class TicketPersonalization extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    if (!this.form) return;
    this.variantIds = new Set(JSON.parse(this.querySelector('[data-personalized-variants]').textContent).map(String));
    this.fields = [...this.querySelectorAll('[data-ticket-field]')];
    this.container = this.querySelector('[data-ticket-fields]');
    this.sync = this.sync.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.observer = new MutationObserver(this.sync);
    // The theme replaces the hidden variant input after fetching variant HTML.
    this.observer.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    this.form.addEventListener('submit', this.onSubmit, true);
    this.sync();
  }

  sync() {
    const active = this.variantIds.has(this.form.querySelector('[name="id"]')?.value);
    this.container.hidden = !active;
    this.fields.forEach(input => {
      input.disabled = !active;
      input.required = active;
      input.setAttribute('aria-required', String(active));
      if (active) {
        input.name = `properties[${input.id.split('-').pop()}]`;
      } else {
        input.removeAttribute('name');
        input.value = '';
      }
    });
    if (this.active !== active) {
      this.querySelectorAll('.required-field-error').forEach(error => error.remove());
      this.fields.forEach(input => this.form.querySelector(`[id="${input.id}Submit"].required-field-error`)?.remove());
    }
    this.active = active;
  }

  onSubmit(event) {
    this.sync();
    if (!this.active) return;
    this.fields.forEach(input => { input.value = input.value.trim(); });
    const invalid = this.fields.find(input => !input.checkValidity());
    if (invalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      invalid.reportValidity();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.form?.removeEventListener('submit', this.onSubmit, true);
  }
}

if (!customElements.get('ticket-personalization')) {
  customElements.define('ticket-personalization', TicketPersonalization);
}
